import { Label, ObjectState } from 'cvat-core-wrapper';

export function groupObjects(objects: ObjectState[], labels: Label[]) {
    if (!labels || labels.length === 0) {
        console.log('Labels not found or empty!');
        return { groups: {}, updatedObjects: [] };
    }

    const groups: Record<string, ObjectState[]> = {};

    labels.forEach((label) => {
        groups[label.name] = [];
    });

    const updatedObjects = objects.map((object) => {
        const labelName = object.label.name;

        if (!groups[labelName]) groups[labelName] = [];
        groups[labelName].push(object);

        return { ...object, groupId: labelName };
    });

    return { groups, updatedObjects };
}